import { GlAlert, GlButton, GlDisclosureDropdownGroup, GlLoadingIcon, GlSprintf, GlLink } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { s__, __ } from '~/locale';
import { logError } from '~/lib/logger';
import { helpPagePath } from '~/helpers/help_page_helper';
import { convertToGraphQLId } from '~/graphql_shared/utils';
import { TYPENAME_PROJECT } from '~/graphql_shared/constants';
import { InternalEvents } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/tracking/index.js?vue3';
import userWorkspacesListQuery from '../../common/graphql/queries/user_workspaces_list.query.graphql';
import { WORKSPACES_DROPDOWN_GROUP_POLL_INTERVAL, WORKSPACES_DROPDOWN_GROUP_PAGE_SIZE, WORKSPACE_STATES, CLICK_NEW_WORKSPACE_BUTTON_EVENT_NAME } from '../constants';
import UpdateWorkspaceMutation from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/workspaces/common/components/update_workspace_mutation.vue?vue3';
import WorkspaceDropdownItem from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/workspaces/dropdown_group/components/workspace_dropdown_item.vue?vue3';
const trackingMixin = InternalEvents.mixin();
export const i18n = {
    workspacesGroupLabel: s__('Workspaces|Your workspaces'),
    newWorkspaceButton: s__('Workspaces|New workspace'),
    noWorkspacesMessage: s__('Workspaces|A workspace is a virtual sandbox environment for your code in GitLab.'),
    loadingWorkspacesFailedMessage: s__('Workspaces|Could not load workspaces'),
    noWorkspacesSupportMessage: __('No agents available to create workspaces. Please consult %{linkStart}Workspaces documentation%{linkEnd} for troubleshooting.')
};
const workspacesHelpPath = helpPagePath('user/workspace/_index.md');
const workspacesTroubleshootingDocsPath = helpPagePath('user/workspace/workspaces_troubleshooting.html');
export default {
    name: 'WorkspacesDropdownGroup',
    components: {
        GlAlert,
        GlButton,
        GlDisclosureDropdownGroup,
        GlLoadingIcon,
        GlLink,
        GlSprintf,
        WorkspaceDropdownItem,
        UpdateWorkspaceMutation
    },
    mixins: [
        trackingMixin
    ],
    props: {
        projectId: {
            type: Number,
            required: true
        },
        projectFullPath: {
            type: String,
            required: true
        },
        newWorkspacePath: {
            type: String,
            required: true
        },
        supportsWorkspaces: {
            type: Boolean,
            required: true
        },
        borderPosition: {
            type: String,
            required: true
        },
        gitRef: {
            type: String,
            required: false,
            default: ''
        }
    },
    apollo: {
        workspaces: {
            query: userWorkspacesListQuery,
            pollInterval: WORKSPACES_DROPDOWN_GROUP_POLL_INTERVAL,
            variables () {
                return {
                    first: WORKSPACES_DROPDOWN_GROUP_PAGE_SIZE,
                    after: null,
                    before: null,
                    includeActualStates: [
                        WORKSPACE_STATES.creationRequested,
                        WORKSPACE_STATES.starting,
                        WORKSPACE_STATES.running,
                        WORKSPACE_STATES.stopping,
                        WORKSPACE_STATES.stopped,
                        WORKSPACE_STATES.terminating,
                        WORKSPACE_STATES.failed,
                        WORKSPACE_STATES.error,
                        WORKSPACE_STATES.unknown
                    ],
                    projectIds: [
                        convertToGraphQLId(TYPENAME_PROJECT, this.projectId)
                    ]
                };
            },
            skip () {
                return !this.supportsWorkspaces;
            },
            update (data) {
                this.loadingWorkspacesFailed = false;
                return data.currentUser.workspaces?.nodes || [];
            },
            error (err) {
                this.loadingWorkspacesFailed = true;
                logError(err);
            }
        }
    },
    data () {
        return {
            workspaces: [],
            loadingWorkspacesFailed: false,
            updateWorkspaceErrorMessage: null
        };
    },
    computed: {
        hasWorkspaces () {
            return this.workspaces.length > 0;
        },
        isLoading () {
            return this.$apollo.queries.workspaces.loading;
        },
        newWorkspacePathWithProjectId () {
            const basePath = `${this.newWorkspacePath}?project=${encodeURIComponent(this.projectFullPath)}`;
            return this.gitRef ? `${basePath}&gitRef=${this.gitRef}` : basePath;
        }
    },
    methods: {
        displayUpdateFailedAlert ({ error }) {
            this.updateWorkspaceErrorMessage = error;
        },
        hideUpdateFailedAlert () {
            this.updateWorkspaceErrorMessage = null;
        },
        handleNewWorkspaceClick () {
            this.trackEvent(CLICK_NEW_WORKSPACE_BUTTON_EVENT_NAME, {
                label: document.body.dataset.page
            });
        }
    },
    i18n,
    workspacesHelpPath,
    workspacesTroubleshootingDocsPath
};
